import { formatISODatePart } from '@flex-packages/date';

const useFormatISODatePart = ({ locale }) => {
  return (params) => {
    const { presetName, isoDatePart } = params;
    return formatISODatePart({
      presetName,
      isoDatePart,
      locale
    });
  };
};

export { useFormatISODatePart };
//# sourceMappingURL=useFormatISODatePartV2.mjs.map
